export const TYPES = {
  EXPANSE: "nav/EXPANSE",
  COLLAPSE: "nav/COLLAPSE",
};
